import { Badge } from '@/components/ui/badge';
import { Spinner } from '@/components/ui/spinner';
import { Card } from '@/components/ui/card';

interface KeywordsListProps {
  keywords: string[];
  isLoading: boolean;
  error: string | null;
}

export const KeywordsList = ({
  keywords,
  isLoading,
  error,
}: KeywordsListProps) => {
  if (isLoading) {
    return (
      <div className='flex items-center justify-center p-8'>
        <Spinner />
        <span className='ml-2'>Loading keywords data...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className='p-4 bg-destructive/10 text-destructive rounded-md'>
        <p className='font-medium'>Error loading data</p>
        <p className='text-sm'>{error}</p>
      </div>
    );
  }

  if (!keywords.length) {
    return (
      <div className='text-center p-8 bg-muted rounded-md'>
        <p className='text-lg font-medium mb-2'>No keywords data available</p>
        <p className='text-sm text-muted-foreground'>No keywords were found.</p>
      </div>
    );
  }

  return (
    <div className='space-y-4'>
      <div className='flex items-center justify-between'>
        <div className='flex items-center space-x-2'>
          <h3 className='text-sm font-medium'>Keywords</h3>
          <Badge variant='outline'>{keywords.length} total</Badge>
        </div>
      </div>

      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
        {keywords.map((keyword, index) => {
          return (
            <Card key={`${keyword}-${index}`} className={`p-4 cursor-pointer transition-colors hover:bg-gray-50`}>
              <div className='flex items-start justify-between'>
                <div className='flex items-center space-x-2'>
                  <span className='text-sm font-medium'>{keyword}</span>
                </div>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
};
